import { AlertTriangle, Trash2, Loader2 } from 'lucide-react';
import BaseModal from '../ui/BaseModal';

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Deletion",
  message = "Are you sure you want to delete this item?",
  itemName = "",
  itemType = "item",
  isLoading = false,
  confirmText = "Delete",
  cancelText = "Cancel",
  formatItemName = null,
}) => {
  return (
    <BaseModal isOpen={isOpen} onClose={onClose} size="sm" showClose={false}>
      {/* Header with warning icon */}
      <div className="flex gap-3 items-start px-6 pt-6 pb-4">
        <div className="flex justify-center items-center flex-shrink-0 w-10 h-10 bg-red-100 rounded-full">
          <AlertTriangle className="w-5 h-5 text-red-600" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          <p className="mt-1 text-sm text-gray-600">{message}</p>
        </div>
      </div>

      <BaseModal.Body>
        {itemName && (
          <div className="p-3 mb-4 rounded-lg border border-gray-200 bg-gray-50">
            <p className="text-sm font-medium text-gray-900">
              {itemType.charAt(0).toUpperCase() + itemType.slice(1)}:
            </p>
            <p className="mt-1 text-sm text-gray-700">
              {formatItemName ? formatItemName(itemName) : itemName}
            </p>
          </div>
        )}

        <div className="p-3 rounded-lg border border-red-200 bg-red-50">
          <div className="flex gap-2 items-start">
            <AlertTriangle className="flex-shrink-0 mt-0.5 w-4 h-4 text-red-600" />
            <p className="text-xs text-red-800">
              <strong>Warning:</strong> This action cannot be undone. The {itemType} will be permanently deleted.
            </p>
          </div>
        </div>
      </BaseModal.Body>

      <BaseModal.Footer>
        <button
          onClick={onClose}
          disabled={isLoading}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 transition-colors hover:bg-gray-50 disabled:opacity-50"
          type="button"
        >
          {cancelText}
        </button>
        <button
          onClick={onConfirm}
          disabled={isLoading}
          className="inline-flex gap-2 items-center px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg transition-colors hover:bg-red-700 disabled:opacity-50"
          type="button"
        >
          {isLoading ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              Deleting...
            </>
          ) : (
            <>
              <Trash2 className="w-4 h-4" />
              {confirmText}
            </>
          )}
        </button>
      </BaseModal.Footer>
    </BaseModal>
  );
};

export default DeleteConfirmationModal;
